export const PHOTO_SERIES_TYPES = {
  FOTOGRAFIJE: "fotografije",
  NEKNJIZNA_GRADJA: "neknjizna_gradja",
} as const;

export type PhotoSeriesType =
  (typeof PHOTO_SERIES_TYPES)[keyof typeof PHOTO_SERIES_TYPES];

export const PHOTO_SERIES_LABELS: Record<PhotoSeriesType, string> = {
  [PHOTO_SERIES_TYPES.FOTOGRAFIJE]: "Fotografije",
  [PHOTO_SERIES_TYPES.NEKNJIZNA_GRADJA]: "Neknjižna građa",
};

export const PHOTO_SERIES_TYPE_OPTIONS = Object.values(PHOTO_SERIES_TYPES).map(
  (value) => ({
    value,
    label: PHOTO_SERIES_LABELS[value],
  }),
);
